import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MdOutlineVerifiedUser, MdClose, MdCalculate } from "react-icons/md";
import { Toast } from "../components_root/ToastContext.jsx";
import "../body_root/popup.css";

export default function Calculatepopup({ data, isOpen, onClose }) {
  const panelRef = useRef(null);
  const { Toastshow } = Toast();
  const navigate = useNavigate();

  const [billamount, setBillamount] = useState(0);
  const [qtyMap, setQtyMap] = useState({});
  const [totalamount, setTotalamount] = useState(0);

  // ✅ Set bill amount when popup opens
  useEffect(() => {
    if (isOpen) {
      setBillamount(Number(data || 0));
      setQtyMap({});
      setTotalamount(0);
    }
  }, [data, isOpen]);

  const indianCurrency = [
    { value: 1, label: "₹1 Coin" },
    { value: 2, label: "₹2 Coin" },
    { value: 5, label: "₹5 Coin" },
    { value: 10, label: "₹10 Note/Coin" },
    { value: 20, label: "₹20 Note" },
    { value: 50, label: "₹50 Note" },
    { value: 100, label: "₹100 Note" },
    { value: 200, label: "₹200 Note" },
    { value: 500, label: "₹500 Note" },
    { value: 2000, label: "₹2000 Note" },
  ];

  // 🔢 Qty Change Handler (MULTI QTY FIXED)
  const handleQtyChange = (denomination, qty) => {
    const quantity = Math.max(0, Number(qty || 0));

    setQtyMap((prev) => {
      const updated = { ...prev, [denomination]: quantity };

      const total = Object.entries(updated).reduce(
        (sum, [denom, q]) => sum + Number(denom) * Number(q),
        0
      );

      setTotalamount(total);
      return updated;
    });
  };

  // ⌨ ESC close
  useEffect(() => {
    if (!isOpen) return;

    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };

    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const returnAmount = Math.max(0, totalamount - billamount);

  return (
    <div className={`div-popup-body ${isOpen ? "show" : ""}`}>
      <div
        ref={panelRef}
        className={`overflow-auto div-panel-right ${
          isOpen ? "slide-in" : "slide-out"
        }`}
      >
        {/* HEADER */}
        <div className="b-bottom items-back">
          <table>
            <tbody>
              <tr>
                <td>
                  <div className="button-ui0 text-h2 bold p-2 fcap">
                    <MdCalculate className="icon" />
                    Calculator
                  </div>
                </td>
                <td width={30}>
                  <div onClick={onClose} className="button-ui0 p-2 cursor">
                    <MdClose className="icon" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* BODY */}
        <div className="p-11">
          <table>
            <tbody>
              {indianCurrency.map((item) => (
                <tr key={item.value}>
                  <td className="fcap text-h2 items-back b-bottom">
                    {item.label}
                  </td>
                  <td width={80} className="items-back-fill b-bottom">
                    <input
                      type="number"
                      min={0}
                      className="border-none text-h2 items-back-fill"
                      placeholder="Qty"
                      value={qtyMap[item.value] || ""}
                      onChange={(e) =>
                        handleQtyChange(item.value, e.target.value)
                      }
                    />
                  </td>
                  <td
                    width={80}
                    className="fcap text-h2 bold items-back b-bottom text-r"
                  >
                    ₹{item.value * (qtyMap[item.value] || 0)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <table className="mt-3">
            <tbody>
              <tr>
                <td className="fcap text-h1 bold items-back-fill-light">
                  Total Amount:
                </td>
                <td
                  width={80}
                  className="fcap text-h1 bold items-back-fill-light text-r"
                >
                  ₹{totalamount}/-
                </td>
              </tr>
              {
                billamount>0 && (<>
                    <tr>
                <td className="fcap text-h2 b-bottom">Receipt Amount:</td>
                <td
                  width={80}
                  className="fcap text-h1 items-back b-bottom text-r green bold"
                >
                  ₹{billamount}/-
                </td>
              </tr>
              <tr>
                <td className="fcap text-h1 b-bottom">Return Amount:</td>
                <td
                  width={80}
                  className="fcap text-hero-sub items-back b-bottom text-r red  bold"
                >
                  ₹{returnAmount}/-
                </td>
              </tr>
                </>) 
              }
          
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
